<div class="modal-header">
    <h6 class="modal-title medium">{{'addOperation'|translate}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left p-4 modal-body advanced-mode">
    <div class="col-lg-6 col-md-6">
        <div class="form-group w-100">
            <label>{{'selectOperation'|translate}} <span class="text-danger medium">*</span> </label>
            <select class="form-control light-bg" [(ngModel)]="operationDetailsData.operation">
                <option *ngFor="let operation of operationList" [attr.value]='operation'
                        [attr.selected]="operation == operationDetailsData.operation ? true : null">{{operation}}
                </option>
            </select>
        </div>
    </div>
    <div class="col-lg-12 col-md-12">
        <div class="form-group w-100">
            <label> {{'name'|translate}} <span class="text-danger medium">*</span></label>
            <input type="text" [(ngModel)]="operationDetailsData.name" class="form-control"/>
        </div>
    </div>
    <div class="col-lg-12 col-md-12">
        <div class="form-group w-100">
            <label> {{'externalURL'|translate}} <span class="text-danger medium">*</span></label>
            <input type="url" [(ngModel)]="operationDetailsData.externalURL" class="form-control"
                   [disabled]="isUpdate"/>
        </div>
    </div>
    <div class="col-lg-6 col-md-6">
        <div class="w-100 form-group">
            <label>Logo</label>
            <input type="file" name="pic" class="form-control" (change)="fileChange($event)"
                   accept=".jpg,.png,.svg,.svgz" #fileInput/>
            <div class="align-v-center justify-content-end">
                <small class="text-primary">Resolution: 160*40px; </small>
                <small class="ml-2 text-primary">size limit: 5mb</small>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary float-right" (click)="cancel()"> {{'cancelProcess'|translate}}</button>
    <button class="btn btn-primary float-right" (click)="save()"> {{'Save'|translate}}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/tools/operations/addOperation.component.html